export default __webpack_public_path__ + "static/lalibrairie-j-mobile@2x-f1a0d4851bc95e5c764b8050d1ead116.jpg";